import { FC, useState } from 'react'
import styled from 'styled-components'
import { AButton } from 'views/components/Analytics'
import { UsContract, UsContractStatuses } from 'modules/domain/usContracts/types'
import { Icons } from '@agro-club/agroclub-shared'
import { useTranslation } from 'react-i18next'
import { useAProgress } from 'hooks/useAProgress'
import { apiClient } from 'modules/utils/httpClient'
import { endpoints } from 'modules/endpoints'
import { ASharedModal, SharedModalContent, SharedModalTitle } from 'views/components/SharedModal'
import ADefaultModalFooter from 'views/components/DefaultModalFooter/ADefaultModalFooter'

const CancelWrapper = styled.div`
  display: flex;
  flex-direction: column;
  bottom: 0;
`

type Props = {
  contract: UsContract
  refetch: (affected?: UsContractStatuses | 'allTabs') => Promise<void>
  onClose: () => void
}

export const CancelContractBtn: FC<Props> = ({ contract, onClose, refetch }) => {
  const { t } = useTranslation(['usContracts'])
  const [confirmModal, setConfirmModal] = useState(false)
  const [closeContractProgress, closeContract] = useAProgress(
    () => apiClient.post(endpoints.closeUsContract(contract.id)),
    {
      eventName: 'closeContract',
      onSuccess: () => {
        refetch('allTabs')
        onClose()
      },
    },
  )
  return (
    <CancelWrapper>
      <AButton
        id="openBlackListUserModal"
        color="destruct"
        background="none"
        border="solid"
        size="big"
        Icon={Icons.IconClear}
        onClick={() => setConfirmModal(true)}
        progress={closeContractProgress}
      >
        {t('cancelContract')}
      </AButton>
      {confirmModal && (
        <ASharedModal id="cancelContractConfirm" onClose={() => setConfirmModal(false)} size="small">
          <SharedModalTitle>{t('cancelConfirm.title')}</SharedModalTitle>
          <SharedModalContent>{t('cancelConfirm.message')}</SharedModalContent>
          <ADefaultModalFooter
            onClose={() => setConfirmModal(false)}
            onConfirm={closeContract}
            progress={closeContractProgress}
          />
        </ASharedModal>
      )}
    </CancelWrapper>
  )
}
